<template>
  <div>
    <Loader v-if="loading" />

    <div v-else class="card p-3">
      <div class="d-flex gap-3">
        <b-button :class="{ disable: comment.status === 2 }" style="background-color: rgba(85, 110, 230, 0.2); border: none; width: 87px" @click="onSetStatus(2)">
          <div class="d-flex justify-content-center gap-1">
            <img v-if="comment.status === 3" :class="{ disable_context: comment.status === 2 }" src="../../../assets/images/dadbanan/Sent Mail.svg" />

            <img v-else :class="{ disable_context: comment.status === 2 }" src="../../../assets/images/dadbanan/checkDisabledMail.svg" />

            <p :class="{ disable_context: comment.status === 2 }" style="margin: 0; color: #556ee6">تایید</p>
          </div>
        </b-button>

        <b-button :class="{ disable: comment.status === 3 }" style="background-color: rgba(244, 106, 106, 0.2); border: none; width: 72px" @click="onSetStatus(3)">
          <div class="d-flex justify-content-center gap-1">
            <i :class="['fas fa-trash-alt', { disable_context: comment.status === 3 }]" style="color: #f46a6a" />

            <p :class="{ disable_context: comment.status === 3 }" style="margin: 0; color: #f46a6a">رد</p>
          </div>
        </b-button>
      </div>

      <div class="mt-5">
        <div class="d-flex gap-3 align-items-center">
          <div>
            <!-- <img v-if="$store.state.idp.userProfileData.image" class="userImg" :src="$store.state.idp.userProfileData.image" /> -->
            <img src="@/assets/images/users/default.png" alt="avatar" class="userImg" />
            <!-- <img  :src="data.item.image" alt="" class="userImg" /> -->
          </div>

          <div class="d-flex flex-column gap-1">
            <p class="m-0 user_name">
              {{ comment.fullName }}
            </p>

            <p class="m-0 user_last_comment">
              {{ TellMeWhen(comment.createdDate) }}
            </p>
          </div>
        </div>
      </div>

      <div class="mt-5">
        <p class="user_comment_text">
          {{ comment.description }}
        </p>
      </div>

      <div class="mt-5">
        <b-button style="background-color: rgba(116, 120, 141, 1); border: none; width: 87px" :disabled="disabledAnswer" @click="onReply">
          <div class="d-flex justify-content-center gap-1">
            <p style="margin: 0; color: #eff2f5">پاسخ</p>

            <img style="color: #eff2f5" src="../../../assets/images/dadbanan/reply.svg" />
          </div>
        </b-button>
      </div>

      <div v-if="answerComment || (comment.children && comment.children.length)" class="mt-5" style="border-top: 1px solid rgba(213, 212, 212, 1)">
        <div class="mt-5">
          <div v-for="(child, index) in comment.children" :key="index" class="mt-5">
            <div class="d-flex gap-3 align-items-center">
              <div>
                <!-- <img v-if="$store.state.idp.userProfileData.image" class="userImg" :src="$store.state.idp.userProfileData.image" /> -->
                <img src="@/assets/images/users/default.png" alt="avatar" class="userImg" />
                <!-- <img  :src="data.item.image" alt="" class="userImg" /> -->
              </div>

              <div class="d-flex flex-column gap-1">
                <p class="m-0 user_name">{{ $store.state.idp.userProfileData.firstname }} {{ $store.state.idp.userProfileData.lastname }}</p>

                <p v-if="child.id" class="m-0 user_last_comment">
                  {{ TellMeWhen(child.createdDate) }}
                </p>
              </div>
            </div>

            <div v-if="child.id" class="mt-5">
              <p class="user_comment_text">
                {{ child.description }}
              </p>
            </div>

            <div v-else class="mt-5">
              <TextAreaInput v-if="answerComment" title="پاسخ" placeholder="متن پیام" v-model="child.description" @input="checkTitle($event)" />
            </div>
          </div>

          <div v-if="answerComment" class="mt-5 d-flex gap-1 justify-content-end">
            <Button text="انصراف" btnClass="cancel btn-border" @click.native="onCancel" />

            <Button :class="{ disable: !enableSubmitButton }" text="ثبت" btnClass="approve btn-border" @click.native="onSubmit" />
          </div>
        </div>
      </div>
    </div>
    <Toast :error="error" :title="message" :showToast="showToast" />
  </div>
</template>
<script>
import moment from 'jalali-moment'
import Button from '../../common/Button.vue'
import Toast from '../../common/Toast.vue'
import Loader from '../../widgets/loader.vue'
import dadbananCommentsProvider from '../../../services/dadban/comments'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'

export default {
  name: 'AddCourse',
  components: { Loader, TextAreaInput, Button, Toast },
  data() {
    return {
      answerComment: false,
      loading: false,
      comment: {},
      lastUpdated: '',
      disabledAnswer: false,
      error: false,
      message: '',
      showToast: false,
      enableSubmitButton: false,
    }
  },

  mounted() {
    this.getUserComments()
  },
  watch: {
    showToast(c) {
      this.$nextTick(() => {
        if (c) this.showToast = false
      })
    },
  },
  methods: {
    checkTitle(event) {
      if (event.length > 0) this.enableSubmitButton = true
      else this.enableSubmitButton = false
    },
    onCancel() {
      this.answerComment = false
      this.disabledAnswer = false

      this.comment.children.forEach((element) => {
        if (!element.id) this.comment.children = this.comment.children.slice(0, -1)
      })
    },
    onReply() {
      this.answerComment = true
      this.comment.children.push({})
      this.disabledAnswer = true
    },
    async onSubmit() {
      const req = await dadbananCommentsProvider.replyToComment({
        productId: this.comment.productId,
        template: this.comment.template,
        parentId: this.comment.id,
        description: this.comment.children[this.comment.children.length - 1].description,
        userId: this.$store.state.idp.userProfileData.id,
      })
      if (req.status !== 200) return
      this.getUserComments()
      this.disabledAnswer = false
      this.answerComment = false
      this.enableSubmitButton = false
    },
    async onSetStatus(mode) {
      const req = await dadbananCommentsProvider.setStatus({
        id: this.comment.id,
        status: mode,
        template: this.comment.template,
      })
      if (req.status !== 200) return
      this.message = 'وضعیت با موفقیت تغییر کرد.'
      this.error = false
      this.showToast = true
      this.getUserComments()
    },
    async getUserComments() {
      this.disabledAnswer = false
      const template = localStorage.getItem('templateId')
      this.loading = true
      const req = await dadbananCommentsProvider.getUserComment({ id: this.$route.params.id, template: Number(template) })
      this.loading = false
      if (req.status === 200) this.comment = req.data.data.output
    },
    calculateTime(lastTime) {
      const time = Number(`${moment(lastTime).local('fa').format('hh')}`)
      return `${time} ساعت پیش`
    },
  },
}
</script>
<style lang="scss" scoped>
.userImg {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  object-fit: cover;
}

.user_name {
  font-size: 16px;
  font-weight: 400;
  color: #4e4e56;
  line-height: 22px;
}

.user_last_comment {
  font-size: 15px;
  font-weight: 400;
  color: #999696;
  line-height: 22px;
}

.user_comment_text {
  font-size: 16px;
  font-weight: 400;
  color: #4e4e56;
  line-height: 43px;
}

.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}
.btn-border {
  border-radius: 4px !important;
}
.approve {
  background-color: #556ee6 !important;
  width: 119px !important;
}

.disable {
  background: #ced4da !important;
  pointer-events: none;
  border-color: #ced4da !important;
}

.disable_context {
  color: white !important;
}
</style>
